// Copyright (C) Microsoft Corporation. All rights reserved.

let $showRelatedTopicsButton = $('#showRelatedTopics');
let $leftNav = $('#learnRenderLeftNav');
let $body = $('body');
let $leftNavMobileHeaderTitle = $('.learnRenderLeftNavMobileViewHeaderTitle');
let $closePaneButton = $('.closePaneButtonContainer');
let $windowElement = $(window);
export function initializeMobileNavigation(): void {
	$showRelatedTopicsButton.on('click', function (): void {
		$leftNav.addClass('learnRenderLeftNavMobileOpen');
		$body.css('overflow', 'hidden');
		$leftNavMobileHeaderTitle.focus();
	});

	$closePaneButton.on('click', function (): void {
		$leftNav.removeClass('learnRenderLeftNavMobileOpen');
		$body.css('overflow', 'auto');
	});

	$windowElement.on('resize', function (): void {
		$leftNav.removeClass('learnRenderLeftNavMobileOpen');
		$body.css('overflow', 'auto');
	});
}
